// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-entry:hover .p-name[data-v-57f06e34]{color:#fd5105}", ""]);
// Exports
module.exports = exports;
